import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { graphql, useStaticQuery } from 'gatsby';
import { LocationLanguageContext } from '../contexts/LocationLanguageContext';
import { LocationLanguageContextType } from '../typings';
import { Languages } from '../utils/getAllSupportedLanguages';

interface DownloadTypeDialogProps {
  open: boolean;
  onDialogClose: (type?: 'pdf') => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    typographyButtons: {
      cursor: 'pointer',
      margin: '2rem 0rem',
      minWidth: '12rem'
    }
  })
);

const DownloadTypeDialog: React.FC<DownloadTypeDialogProps> = ({ open, onDialogClose }) => {
  const data = useStaticQuery(
    graphql`
      query DownloadDialogQuery {
        allStrapiDownloadDialog {
          nodes {
            DownloadAsLabel
            locale
          }
        }
      }
    `
  );

  const locationLanguage = React.useContext<LocationLanguageContextType | null>(LocationLanguageContext);
  const language: string = locationLanguage?.language ?? Languages.English;

  const downloadDialogContent = data.allStrapiDownloadDialog.nodes.find((x: any) => x.locale === language);
  const classes = useStyles();

  const handleClose = () => {
    onDialogClose();
  };

  const handlePDF = () => {
    onDialogClose('pdf');
  };
  return (
    <Dialog onClose={handleClose} aria-labelledby='Download Type Dialog' open={open}>
      <DialogContent>
        {downloadDialogContent ? <Typography variant='h6'>{downloadDialogContent.DownloadAsLabel}</Typography> : null}
        <Typography onClick={handlePDF} className={classes.typographyButtons}>
          PDF
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadTypeDialog;
